import {
  selectMovedUser,
  selectUserForceMovePopup,
  selectUserForceMoveDialog,
} from "modules/userForceMove/redux/selectors";
import { useSelector } from "react-redux";
import { useUserForceMoveListener } from "modules/userForceMove/hooks";
import { selectIsEventManager } from "modules/event/selectors";
import { selectIsInBroadcast } from "modules/broadcast/redux/selectors";
import { UserForceMoveDialog } from "../UserForceMoveDialog";
import { UserForceMoveCancel } from "../UserForceMoveCancel";
import { UserForceMoveTimer } from "../UserForceMoveTimer";

export const UserForceMoveSubscriber = () => {
  const showDialog = useSelector(selectUserForceMoveDialog);
  const showPopup = useSelector(selectUserForceMovePopup);
  const movedUser = useSelector(selectMovedUser);
  const isEventManager = useSelector(selectIsEventManager);
  const isInBroadcast = useSelector(selectIsInBroadcast);

  useUserForceMoveListener();

  if (isInBroadcast) {
    return null;
  }

  return (
    <>
      {showDialog && movedUser && <UserForceMoveDialog user={movedUser} />}
      {isEventManager && showPopup && <UserForceMoveCancel />}
      {!isEventManager && showPopup && <UserForceMoveTimer />}
    </>
  );
};
